import type { Signal, SignalList } from '../../../shared/types';

type Counts = SignalList['counts'];
type List = { signals: readonly Signal[]; hidden?: readonly Signal[]; counts?: Counts };

/** Old cached payloads have only the loaded rows; never infer an unseen remainder. */
export const signalCounts = (list: List): Counts => {
  if (list.counts) return { ...list.counts };
  const counts = { top: 0, queue: 0, hidden: 0 };
  for (const s of list.signals) counts[s.bucket === 'top' ? 'top' : 'queue'] += 1;
  counts.hidden = list.hidden?.length ?? 0;
  return counts;
};

export const adjustSignalCount = (counts: Counts, signal: Signal | undefined, delta: number): void => {
  const bucket = signal?.bucket;
  if (bucket === 'top' || bucket === 'queue' || bucket === 'hidden')
    counts[bucket] = Math.max(0, counts[bucket] + delta);
};

export const signalSummary = (list: List): { total: number; partial: string | null } => {
  const counts = signalCounts(list);
  const total = counts.top + counts.queue;
  const loaded = list.signals.length;
  return {
    total,
    partial: total > loaded
      ? `Loaded ${loaded} of ${total} new businesses, highest-scoring first. Filters apply to loaded businesses.`
      : null,
  };
};
